<template>
  <div class="regulatory-update-personal-register">
    <NavBar class="regulatory-update-personal-register__navbar">
      <template #left>
        <ButtonIconContextual label="voltar" icon="EA0030" @click="back" />
      </template>
    </NavBar>
    <LoaderIndicator v-if="isLoading" with-container />
    <RegulatoryUpdatePersonalData
      class="regulatory-update-personal-register__content"
      :show-content="!isLoading"
      came-from="personalRegisterUpdate"
      @go-to-next-page="goToNextRoute"
      @set-is-loading="setIsLoading"
      @notify-error="notifyError"
    />
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import {
  NavBar,
  ButtonIconContextual,
  LoaderIndicator
} from '@warrenbrasil/nebraska-web';
import RegulatoryUpdatePersonalData from '@/modules/account/views/RegulatoryUpdate/views/RegulatoryUpdatePersonalData/RegulatoryUpdatePersonalData.vue';
import {
  goToNextRoute,
  goToPreviousRoute
} from '@/modules/common/store/RegulatoryUpdateRoutesOrchestrator';
import { notify } from '@/modules/common/helpers/notification';
import { NotificationTypes } from '@/modules/common/services/http/notification';

const isLoading = ref(true);

function back() {
  goToPreviousRoute();
}

function setIsLoading(loading: boolean) {
  isLoading.value = loading;
}

function notifyError() {
  notify({
    group: 'wrn-notifications',
    text: 'Houve um problema ao salvar seus dados. Aguarde alguns instantes e tente novamente.',
    type: NotificationTypes.error
  });
}
</script>

<style lang="less" scoped>
.regulatory-update-personal-register {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;

  &__navbar {
    position: absolute;
    top: 0;
    width: 100%;

    border: 0;
    padding: 0 @size-spacing-x350;

    @media @mobileDown {
      padding: 0;
    }
  }

  &__content {
    max-width: 672px;
    width: 100%;
    height: 100%;

    padding: @size-spacing-x400;
    padding-top: @size-spacing-x1800;

    @media @mobileDown {
      padding-top: @size-spacing-x1400;
    }
  }
}
</style>
